<template>
    <div>
        <slot
            :dataset="dataset"
            :country="dataset.country"
            :language="dataset.language"
            :baseUrl="dataset.baseUrl"
            :campaignName="dataset.campaignName"
            :utm="utm"
        />
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from 'vue-class-component';

@Component
export default class DataSet extends Vue {

    get dataset() {
        const dataset = this.$dataset as Array<string>;
        return {
            country: 'FR',
            language: 'fr',
            baseUrl: '/',
            utm: '',
            campaignName: '',
            ...(dataset || {})
        };
    }

    get utm() {
        return this.dataset.utm ? JSON.parse(this.dataset.utm) : {}
    }
}

</script>
